import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Card, Grid, makeStyles, Typography } from '@material-ui/core';
import SVG from 'react-inlinesvg';
import { FavoriteBorder, ChatBubbleOutlineOutlined, ThumbUpOutlined } from '@material-ui/icons';

import { toAbsoluteUrl } from '../../../../_metronic/_helpers';

const interactionTypes = [
	{
		name: 'like',
		icon: (
			<IconCircle color='#FFC75F'>
				<FavoriteBorder style={{ color: '#FFC75F' }} />
			</IconCircle>
		),
		score: 80,
	},
	{
		name: 'comment',
		icon: (
			<IconCircle color='#D55DB1'>
				<ChatBubbleOutlineOutlined style={{ color: '#D55DB1' }} />
			</IconCircle>
		),
		score: 2,
	},
	{
		name: 'vote',
		icon: (
			<IconCircle color='#835FC2'>
				<ThumbUpOutlined style={{ color: '#835FC2' }} />
			</IconCircle>
		),
		score: -8,
	},
];

function IconCircle({ color, size, children }) {
	size = size || 48;

	return (
		<div
			className='d-flex justify-content-center align-items-center'
			style={{ width: size, height: size, backgroundColor: color + '16', borderRadius: '50%' }}
		>
			{children}
		</div>
	);
}

export function Interactions() {
	const { statistics, totals } = useSelector((state) => state.dashboard, shallowEqual);
	const [interactionsCount, setInteractionsCount] = useState({
		like: 0,
		comment: 0,
		vote: 0,
	});

	useEffect(() => {
		if (!statistics || !statistics.length) {
			setInteractionsCount({
				like: 0,
				comment: 0,
				vote: 0,
			});
			return;
		}
		const dailyNewPosts = statistics.map((val) => {
			return {
				...val.metrics.Interactions,
			}
		})
		const count = {};
		interactionTypes.forEach((type) => {
			count[type.name] = dailyNewPosts.reduce((a, b) => a + (b[type.name] || 0), 0);
		});
		setInteractionsCount(count);
	}, [statistics]);

	const classes = useStyles();

	return (
		<Card className={classes.container}>
			<Grid container justify='space-between' alignItems='center'>
				<div className='d-flex align-items-center'>
					<span className='symbol symbol-circle symbol-50 symbol-light mr-2'>
						<span className='symbol-label'>
							<span className='svg-icon svg-icon-lg svg-icon-dark'>
								<SVG src={toAbsoluteUrl('/assets/interaction.svg')}></SVG>
							</span>
						</span>
					</span>
					<div className='d-flex flex-column' style={{ marginLeft: 4 }}>
						<span className={classes.title}>Interactions</span>
						<Typography className={classes.score}>{totals?.Interactions || 0} total interactions</Typography>
					</div>
				</div>
			</Grid>
			<Grid style={{ marginTop: 48 }} container justify='space-around'>
				{interactionTypes.map((p, index) => (
					<div key={index} className='d-flex flex-column align-items-center justify-content-center'>
						{p.icon}
						<Typography className={classes.subContent}>{interactionsCount[p.name]}</Typography>
						<Typography className={classes.subTitle}>{p.name}</Typography>
					</div>
				))}
			</Grid>
		</Card>
	);
}

const useStyles = makeStyles(() => ({
	container: {
		padding: 20,
		boxShadow: 'none !important',
		borderRadius: 10,
		height: '100%',
	},
	title: {
		fontSize: 16,
		color: '#353146',
		lineHeight: '16px',
	},
	score: {
		fontSize: 14,
		color: '#908BA4',
	},
	subTitle: {
		fontSize: 12,
		color: '#353146',
		textAlign: 'center',
		marginBottom: 24,
		textTransform: 'capitalize',
	},
	subContent: {
		color: '#0D0C12',
		fontSize: 24,
		fontWeight: 600,
		lineHeight: '24px',
		textAlign: 'center',
		marginTop: 24,
		marginBottom: 12,
	},
	improve: {
		textAlign: 'center',
		fontWeight: 600,
	},
}));
